import { LocaleStrings } from '../keys';

const id: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'CERITA',
  nav_create: 'BUAT',
  nav_login: 'Masuk',

  page_title_main: 'Story Craft - Halaman Utama',
  section_browse_by_category: 'Jelajahi berdasarkan Kategori',
  section_explore_new_games: 'Jelajahi Game Baru',
  section_popular: 'Populer',
  section_trending: 'Trending',
  section_trending_now: 'Trending Sekarang',
  section_popular_picks: 'Pilihan Populer',
  section_recent_stories: 'Cerita terbaru dilihat',
  section_new_stories: 'Cerita baru',
  btn_load_more_games: 'Muat lebih banyak ({count} lagi)',
  text_showing_games: 'Menampilkan {visible} dari {total} game',
  text_no_category_games: 'Tidak ada game {category} ditemukan.',
  text_category_games: 'Game {category}',
  text_error_loading_games: 'Gagal memuat game: {error}',

  tell_us_tagline: 'Story Craft: Tempat fanfiksi menjadi cerita yang bisa dimainkan.',
  tell_us_subtitle: 'Mulai game Anda hari ini!',
  btn_create_now: 'Buat Sekarang',

  section_comments: 'Komentar ({count})',
  text_no_comments: 'Belum ada komentar. Jadilah yang pertama berbagi pemikiran!',
  btn_load_more_comments: 'Muat lebih banyak komentar',
  text_posting_comment: 'Mengirim komentar...',
  text_failed_load_comments: 'Gagal memuat komentar',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'Game Tidak Ditemukan - Story Craft',
  page_title_game_info: 'Info Game - Story Craft',
  btn_play_now: 'Main Sekarang',
  btn_rate: 'Nilai',
  section_about: 'Tentang',
  section_tags: 'Tag',
  text_views: '{count} kali dilihat',
  text_your_rating: 'Penilaian Anda: {rating} - {title}',
  text_game_id: 'ID Game: {id}',
  text_no_description: 'Game ini tidak memiliki deskripsi.',
  text_game_not_found: 'Game tidak ditemukan',
  text_failed_load_game: 'Gagal memuat informasi game',

  section_similar_games: 'Game Serupa',
  text_failed_load_similar: 'Gagal memuat game serupa',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'Komentar Story Craft - Tanya dan jawab di sini',

  section_featured: 'Story Craft Unggulan',
  section_top_genre: 'Top Cerita {genre}',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: 'Rating {rating}',
  rating_warn_teen_body: 'Cerita ini berrating T (Teen 13+). Mungkin mengandung kekerasan ringan, tema sugestif, atau konten yang tidak sesuai untuk pembaca muda.',
  rating_warn_mature_body: 'Cerita ini berrating M (Mature 18+). Mungkin mengandung kekerasan kuat, tema dewasa, atau konten yang hanya ditujukan untuk pembaca dewasa.',
  rating_warn_continue: 'Lanjutkan',
  rating_warn_go_back: 'Kembali',
  rating_warn_confirm_teen: 'Saya mengonfirmasi bahwa saya berusia 13 tahun atau lebih.',
  rating_warn_confirm_mature: 'Saya mengonfirmasi bahwa saya berusia 18 tahun atau lebih.',

  rating_section_title: 'Rating Konten',
  rating_label_e: 'Semua Umur',
  rating_label_t: 'Remaja 13+',
  rating_label_m: 'Dewasa 18+',
  rating_desc_e: 'Cocok untuk pembaca segala usia. Berisi konten yang sesuai untuk semua orang.',

  hero_dialog_1: 'Harry Potter tidak sengaja mengucapkan mantra yang salah pada ceritamu lagi.',
  hero_dialog_2: 'Scheherazade masih menceritakan satu kisah terakhir kepada Mina sebelum matahari terbit…',
  hero_dialog_3: 'Sherlock Holmes menemukan plot hole yang hilang dan menolak melanjutkan loading.',
  hero_dialog_4: 'Dracula sedang menunggu izin untuk memasuki bab 2.',
  hero_dialog_5: 'Frodo entah bagaimana menjatuhkan file save-mu ke dalam Gunung Doom.',
  hero_dialog_6: 'Harry Potter dan Mina sedang berdebat tentang siapa yang menyebabkan keruntuhan timeline.',
  hero_dialog_7: 'Cinderella melewatkan tengah malam lagi, jadi layar loading diperpanjang.',
  hero_dialog_8: 'Romeo dan Juliet sampai ke ending burukmu sedikit terlalu awal.',
  hero_dialog_9: 'Alice membuka lubang kelinci yang salah dan masuk ke folder draft-mu.',
  hero_dialog_10: 'Mina berjanji tidak akan membaca buku terlarang lagi. Mina berbohong.',
  hero_dialog_11: 'Merlin sedang memperbaiki bug ajaib di mesin cerita.',
  hero_dialog_12: 'Odysseus sudah mencoba mencapai bab berikutnya selama 10 tahun.',
  hero_dialog_13: 'Dr. Frankenstein menyentuh codebase. Tidak ada yang merasa aman lagi.',
  hero_dialog_14: 'Peter Pan menolak membiarkan cerita ini tumbuh dewasa.',
  hero_dialog_15: 'Sang Pangeran Kecil bertanya kepada Mina mengapa orang dewasa menulis begitu banyak ending tragis.',
};
export default id;
